<template>
    <div id="usergroup-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Live Quiz',
                    to: { path: '/addlivequiz' },
                    exact: true,
                },
                {
                    text: !$route.query.id
                        ? 'Tambah Sesi Live Quiz'
                        : 'Ubah Sesi Live Quiz',
                },
            ]"
            divider=">"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ !$route.query.id ? "Tambah Sesi" : "Ubah Sesi" }}
        </h3>

        <v-card plain class="pa-4">
            <v-list-item two-line>
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Nama Sesi
                    </v-list-item-title>
                    <v-text-field
                        placeholder="Nama Sesi"
                        outlined
                        v-model="form.session_name"
                    ></v-text-field>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Teacher
                    </v-list-item-title>

                    <v-select
                        id="live_class_mapel"
                        class="pa-0"
                        v-model="form.mapel"
                        :items="mapelList"
                        outlined
                        item-text="nama"
                        item-value="id"
                        placeholder="Pilih Teacher"
                        chips
                    >
                        <template v-slot:selection="{ item }">
                            <v-list-item class="pa-0 ma-0">
                                <v-list-item-avatar>
                                    <img :src="item.picture" />
                                </v-list-item-avatar>
                                <v-list-item-title>{{
                                    item.nama
                                }}</v-list-item-title>
                            </v-list-item>
                        </template>
                        <template v-slot:item="{ item }">
                            <v-list-item-avatar>
                                <img :src="item.picture" />
                            </v-list-item-avatar>
                            <v-list-item-title>{{
                                item.nama
                            }}</v-list-item-title>
                        </template>
                    </v-select>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Mata Pelajaran
                    </v-list-item-title>

                    <v-select
                        id="live_class_mapel"
                        class="pa-0"
                        v-model="form.mapel"
                        :items="mapelList"
                        outlined
                        item-text="nama"
                        item-value="id"
                        placeholder="Pilih mata pelajaran"
                        chips
                    >
                        <template v-slot:selection="{ item }">
                            <v-list-item class="pa-0 ma-0">
                                <v-list-item-avatar>
                                    <img :src="item.picture" />
                                </v-list-item-avatar>
                                <v-list-item-title>{{
                                    item.nama
                                }}</v-list-item-title>
                            </v-list-item>
                        </template>
                        <template v-slot:item="{ item }">
                            <v-list-item-avatar>
                                <img :src="item.picture" />
                            </v-list-item-avatar>
                            <v-list-item-title>{{
                                item.nama
                            }}</v-list-item-title>
                        </template>
                    </v-select>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Kuota
                    </v-list-item-title>
                    <v-text-field
                        placeholder="Jumlah kuota"
                        outlined
                        v-model="form.session_name"
                    ></v-text-field>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Jenjang *
                    </v-list-item-title>

                    <v-radio-group
                        row
                        v-model="form.level"
                        @change="form.grade = []"
                    >
                        <v-radio
                            id="live_class_jenjang_sd"
                            label="SD"
                            value="SD"
                            class="jenjang-selection"
                            active-class="act-radio-btn"
                        ></v-radio>
                        <v-radio
                            id="live_class_jenjang_smp"
                            label="SMP"
                            value="SMP"
                            class="jenjang-selection"
                            active-class="act-radio-btn"
                        ></v-radio>
                        <v-radio
                            id="live_class_jenjang_sma"
                            label="SMA"
                            value="SMA"
                            class="jenjang-selection"
                            active-class="act-radio-btn"
                        ></v-radio>
                    </v-radio-group>
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line>
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Kelas *
                    </v-list-item-title>
                    <div v-if="form.level === 'SD'" class="d-inline">
                        <v-checkbox
                            id="live_class_kelas_1"
                            label="1"
                            :value="1"
                            v-model="form.grade"
                            class="pa-2 ma-0 d-inline-flex"
                            outlined
                        />
                        <v-checkbox
                            id="live_class_kelas_2"
                            label="2"
                            :value="2"
                            v-model="form.grade"
                            class="pa-2 ma-0 d-inline-flex"
                            outlined
                        />
                        <v-checkbox
                            id="live_class_kelas_3"
                            label="3"
                            :value="3"
                            v-model="form.grade"
                            class="pa-2 ma-0 d-inline-flex"
                            outlined
                        />
                        <v-checkbox
                            id="live_class_kelas_4"
                            label="4"
                            :value="4"
                            v-model="form.grade"
                            class="pa-2 ma-0 d-inline-flex"
                            outlined
                        />
                        <v-checkbox
                            id="live_class_kelas_5"
                            label="5"
                            :value="5"
                            v-model="form.grade"
                            class="pa-2 ma-0 d-inline-flex"
                            outlined
                        />
                        <v-checkbox
                            id="live_class_kelas_6"
                            label="6"
                            :value="6"
                            v-model="form.grade"
                            class="pa-2 ma-0 d-inline-flex"
                            outlined
                        />
                    </div>
                    <div v-if="form.level === 'SMP'" class="d-inline">
                        <v-checkbox
                            id="live_class_kelas_7"
                            label="7"
                            :value="7"
                            v-model="form.grade"
                            class="pa-2 ma-0 d-inline-flex"
                            outlined
                        />
                        <v-checkbox
                            id="live_class_kelas_8"
                            label="8"
                            :value="8"
                            v-model="form.grade"
                            class="pa-2 ma-0 d-inline-flex"
                            outlined
                        />
                        <v-checkbox
                            id="live_class_kelas_9"
                            label="9"
                            :value="9"
                            v-model="form.grade"
                            class="pa-2 ma-0 d-inline-flex"
                            outlined
                        />
                    </div>
                    <div v-if="form.level === 'SMA'" class="d-inline">
                        <v-checkbox
                            id="live_class_kelas_10"
                            label="10"
                            :value="10"
                            v-model="form.grade"
                            class="pa-2 ma-0 d-inline-flex"
                            outlined
                        />
                        <v-checkbox
                            id="live_class_kelas_11"
                            label="11"
                            :value="11"
                            v-model="form.grade"
                            class="pa-2 ma-0 d-inline-flex"
                            outlined
                        />
                        <v-checkbox
                            id="live_class_kelas_12"
                            label="12"
                            :value="12"
                            v-model="form.grade"
                            class="pa-2 ma-0 d-inline-flex"
                            outlined
                        />
                    </div>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-row>
                    <v-col cols="6">
                        <v-list-item two-line class="pa-1">
                            <v-list-item-content>
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Waktu Mulai *
                                </v-list-item-title>
                                <v-container>
                                    <v-row>
                                        <v-col cols="6" class="pa-0">
                                            <v-menu
                                                ref="menu"
                                                v-model="startDate.option"
                                                :close-on-content-click="false"
                                                transition="slide-y-reverse-transition"
                                                offset-y
                                                min-width="auto"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-text-field
                                                        id="live_class_start_date"
                                                        v-model="
                                                            startDate.value
                                                        "
                                                        append-icon="mdi-calendar"
                                                        placeholder="Tanggal"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        outlined
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-if="startDate.option"
                                                    v-model="startDate.value"
                                                    :min="
                                                        new Date()
                                                            .toISOString()
                                                            .slice(0, 10)
                                                    "
                                                    no-title
                                                    @change="
                                                        startDate.option = false
                                                    "
                                                    scrollable
                                                >
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-menu
                                                ref="menu"
                                                v-model="startTime.option"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="slide-y-reverse-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-text-field
                                                        id="live_class_start_time"
                                                        v-model="
                                                            startTime.value
                                                        "
                                                        outlined
                                                        placeholder="Jam"
                                                        append-icon="mdi-clock-time-four-outline"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-time-picker
                                                    v-if="startTime.option"
                                                    v-model="startTime.value"
                                                    @change="
                                                        startTime.option = false
                                                    "
                                                    format="24hr"
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                    <v-col cols="6" class="pa-0">
                        <v-list-item two-line class="py-0 px-1">
                            <v-list-item-content>
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Waktu Berakhir *
                                </v-list-item-title>
                                <v-container>
                                    <v-row>
                                        <v-col cols="6" class="pa-0">
                                            <v-menu
                                                ref="menu"
                                                v-model="endDate.option"
                                                :close-on-content-click="false"
                                                transition="slide-y-reverse-transition"
                                                offset-y
                                                min-width="auto"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-text-field
                                                        id="live_class_end_date"
                                                        v-model="endDate.value"
                                                        append-icon="mdi-calendar"
                                                        placeholder="Tanggal"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        outlined
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-if="endDate.option"
                                                    v-model="endDate.value"
                                                    :min="
                                                        new Date()
                                                            .toISOString()
                                                            .slice(0, 10)
                                                    "
                                                    no-title
                                                    scrollable
                                                    @change="
                                                        endDate.option = false
                                                    "
                                                >
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-menu
                                                ref="menu"
                                                v-model="endTime.option"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="slide-y-reverse-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-text-field
                                                        id="live_class_end_time"
                                                        v-model="endTime.value"
                                                        outlined
                                                        placeholder="Jam"
                                                        append-icon="mdi-clock-time-four-outline"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-time-picker
                                                    v-if="endTime.option"
                                                    v-model="endTime.value"
                                                    @change="
                                                        endTime.option = false
                                                    "
                                                    format="24hr"
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                </v-row>
            </v-list-item>

            <v-card-actions class="py-2">
                <v-spacer></v-spacer>
                <v-btn text @click="$router.push({ path: '/addlivequiz' })">
                    Batal
                </v-btn>
                <v-btn
                    color="primary"
                    @click="!$route.query.id ? saveData() : editData()"
                >
                    Simpan
                </v-btn>
            </v-card-actions>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import Spinner from "@/modules/global/components/plugins/Spinner";
import SalesService from "@/modules/global/services/sales.js";

export default {
    name: "usergroup-form",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            isLoading: false,
            packages: [],
            contens: [],
            pageNumber: 1,
            startDate: {
                option: false,
                value: null,
            },
            startTime: {
                option: false,
                value: null,
            },
            endTime: {
                option: false,
                value: null,
            },
            endDate: {
                option: false,
                value: null,
            },
            form: {
                user_group_name: "",
                description: "",
                is_specific: false,
            },
            headerPackages: [
                { text: "No.", value: "no" },
                { text: "Nama", value: "name" },
                { text: "Jenjang", value: "level" },
                { text: "Grade", value: "grade" },
            ],
            headerContens: [
                { text: "No.", value: "no" },
                { text: "Nama", value: "name" },
                { text: "Jenjang", value: "level" },
                { text: "Grade", value: "grade" },
                { text: "Jenis", value: "type" },
            ],
        };
    },

    mounted: function () {
        if (this.$route.query.id) {
            this.fetchData();
        }
    },

    methods: {
        fetchData() {
            var context = this;
            var userGroupId = this.$route.query.id;
            this.isLoading = true;

            SalesService.getDetailUserGroup(userGroupId, function (result) {
                context.isLoading = false;

                if (result.success) {
                    (context.form.user_group_name =
                        result.data.user_group_name),
                        (context.form.description = result.data.description),
                        (context.form.is_specific = result.data.is_specific);
                } else {
                    context.$store.commit("showAlert", {
                        message: `Terjadi Kesalahan!`,
                        submessage: result.message,
                        type: "error",
                    });
                }
            });
            this.getPackages();
            this.getContents();
        },

        getPackages() {
            var context = this;
            var userGroupId = this.$route.query.id;
            this.isLoading = true;

            SalesService.getPackageByUserGroup(userGroupId, function (result) {
                if (result.success) {
                    context.totalPackage = result.data.total_data;
                    result.data.packages.forEach((items, index) => {
                        var row = {
                            no: index,
                            name: items.package_name,
                            level: items.level,
                            grade: items.grade
                                .sort()
                                .toString()
                                .replace(/[\[\]']+/g, ""),
                        };
                        context.packages.push(row);
                    });
                }
                context.isLoading = false;
            });
        },

        getContents() {
            var context = this;
            var userGroupId = this.$route.query.id;
            this.isLoading = true;

            SalesService.getContentByUserGroup(userGroupId, function (result) {
                if (result.success) {
                    // context.totalContent = result.data.total_data;
                    result.data.packages.forEach((items, index) => {
                        var row = {
                            no: index,
                            name: items.content_name,
                            level: items.level,
                            grade: items.grade,
                            type: items.content_type,
                        };
                        context.contens.push(row);
                    });
                }
                context.isLoading = false;
            });
        },

        validateForm: function () {
            var err = false;
            if (
                this.form.user_group_name == null ||
                this.form.user_group_name == "" ||
                this.form.user_group_name == " "
            ) {
                this.$store.commit("showAlert", {
                    message: `Nama User Group wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (
                this.form.description == null ||
                this.form.description == "" ||
                this.form.description == " "
            ) {
                this.$store.commit("showAlert", {
                    message: `Deskripsi wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            return !err;
        },

        saveData: function () {
            // if (this.validateForm()) {
            //   this.isLoading = true;
            //   var context = this;
            //   var body = {
            //     user_group_name: this.form.user_group_name,
            //     description: this.form.description,
            //     is_specific: this.form.is_specific,
            //   };
            //   SalesService.addUserGroup(body, function (result) {
            //     context.isLoading = false;
            //     if (result.success) {
            //       context.$store.commit("showAlert", {
            //         message: "Berhasil Menyimpan Data!",
            //         type: "success",
            //       });
            //       context.$router.push({ path: "/user-group" });
            //     } else {
            //       context.$store.commit("showAlert", {
            //         message: "Terjadi Kesalahan",
            //         type: "error",
            //       });
            //     }
            //   });
            // }
        },

        editData: function () {
            // if (this.validateForm()) {
            //   this.isLoading = true;
            //   var context = this;
            //   var body = {
            //     user_group_name: this.form.user_group_name,
            //     description: this.form.description,
            //     is_specific: this.form.is_specific,
            //   };
            //   SalesService.updateUserGroup(
            //     this.$route.query.id,
            //     body,
            //     function (result) {
            //       context.isLoading = false;
            //       if (result.success) {
            //         context.$store.commit("showAlert", {
            //           message: `Berhasil Menyimpan Data!`,
            //           type: "success",
            //         });
            //       } else {
            //         context.$store.commit("showAlert", {
            //           message: `Terjadi kesalahan`,
            //           submessage: "Data tidak tersimpan",
            //           type: "error",
            //         });
            //       }
            //       context.$router.push({ path: "/user-group" });
            //     }
            //   );
            // }
        },
    },
};
</script>



// WEBPACK FOOTER //
// AddLiveQuizForm.vue?bff0fc82